import { render, staticRenderFns } from "./PatSnapAvatarRenderer.vue?vue&type=template&id=32ce72f4"
import script from "./PatSnapAvatarRenderer.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatSnapAvatarRenderer.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports